import type { ReactNode } from 'react'
import { forwardRef } from 'react'

import type { ButtonProps } from './Button'
import Button from './Button'

type AccessibleName =
  | {
      /**
       * Icon buttons require an accessible name.
       * It's also encouraged to add a tooltip to the icon button.
       */
      'aria-label': string
      'aria-labelledby'?: never
    }
  | {
      'aria-label'?: never
      /**
       * Icon buttons require an accessible name.
       * It's also encouraged to add a tooltip to the icon button.
       */
      'aria-labelledby': string
    }

export type IconButtonProps = Omit<
  ButtonProps,
  'onlyIcon' | 'iconPosition' | 'children' | 'aria-label' | 'aria-labelledby'
> & {
  children?: ReactNode
} & AccessibleName

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children = null, ...props }, ref) => (
    <Button {...props} ref={ref} onlyIcon children={children} />
  ),
)

export default IconButton
